import { Component, Input } from '@angular/core';

@Component({
  selector: 'globot-no-info',
  template: `
    <div class="container-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="101"
        height="94"
        viewBox="0 0 101 94"
        fill="none"
      >
        <g opacity="0.6">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.375 43.8561C0.375 19.003 23.5005 0 50.5 0C77.4995 0 100.625 19.003 100.625 43.8561C100.625 68.7092 77.4995 87.7122 50.5 87.7122C47.3459 87.7122 44.1918 87.4636 41.077 86.9401C33.9312 92.0835 25.2019 94.5308 16.4202 93.8764C15.6088 93.8241 14.8367 93.5493 14.1561 93.1043C13.4756 92.6593 12.9389 92.0442 12.5725 91.3244C12.206 90.6046 12.0228 89.8063 12.0621 88.9948C12.1014 88.1834 12.3369 87.3981 12.7557 86.7176C14.8105 83.4065 15.936 79.6111 16.0276 75.711C6.49993 67.8193 0.375 56.5379 0.375 43.8561Z"
            fill="#DA94FB"
          />
          <path
            d="M50.5001 73.408C70.7386 73.408 87.1451 60.7047 87.1451 45.0343C87.1451 29.364 70.7386 16.6607 50.5001 16.6607C30.2617 16.6607 13.8552 29.364 13.8552 45.0343C13.8552 60.7047 30.2617 73.408 50.5001 73.408Z"
            fill="white"
          />
          <path
            d="M38.695 36.2924C41.7182 36.2924 44.1655 38.7397 44.1655 41.7629V49.0134C44.1655 52.0366 41.7182 54.4839 38.695 54.4839C35.6718 54.4839 33.2244 52.0366 33.2244 49.0134V41.7629C33.2244 38.7397 35.6718 36.2924 38.695 36.2924Z"
            fill="#DA94FB"
          />
          <path
            d="M63.3264 36.2924C66.3496 36.2924 68.797 38.7397 68.797 41.7629V49.0134C68.797 52.0366 66.3496 54.4839 63.3264 54.4839C60.3032 54.4839 57.8558 52.0366 57.8558 49.0134V41.7629C57.8558 38.7397 60.3032 36.2924 63.3264 36.2924Z"
            fill="#DA94FB"
          />
        </g>
      </svg>
      <h1 class="mt-5">{{ tile }}</h1>
      <p>{{ message }}</p>
      <!-- Optional CTA slot (GLOB-1868): callers may project a button/action here.
           Purely additive — existing usages that don't project anything are unaffected. -->
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./no-info.component.scss'],
})
export class NoInfoComponent {
  @Input() tile: string = '';
  @Input() message: string = 'No hay información';
}
